import React, { useState } from "react";
import { fetch } from "../../utils";

const Contact = () => {
    const [form, setForm] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const handleChange = (e) => {
        setForm((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
        setError("");
        setSuccess("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        if (!form.name.trim()) return setError("Please enter your name.");
        if (!form.email.trim()) return setError("Please enter your email.");

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) {
            return setError("Please enter a valid email address.");
        }

        if (!form.phone.trim()) return setError("Please enter your phone number.");

        if (!/^[0-9+\-\s]{10,15}$/.test(form.phone.trim())) {
            return setError("Please enter a valid phone number.");
        }

        if (!form.message.trim()) return setError("Please enter your message.");

        try {
            setLoading(true);

            const response = await fetch(
                "form/save-contact-us",
                "post",
                {
                    full_name: form.name.trim(),
                    email: form.email.trim(),
                    phone_no: form.phone.trim(),
                    message: form.message.trim(),
                },
                {
                    "Content-Type": "application/json",
                }
            );

            if (!response?.data?.success) {
                throw new Error(
                    response?.data?.message || "Something went wrong."
                );
            }

            setSuccess(
                response.data.message ||
                "Thank you! Your message has been submitted successfully."
            );

            setForm({
                name: "",
                email: "",
                phone: "",
                message: "",
            });
        } catch (err) {
            setError(
                err?.response?.data?.message ||
                err?.message ||
                "Something went wrong. Please try again."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <section className="p70 breadcru">
                <div className="container">
                    <div className="row">
                        <nav>
                            <ol className="breadcrumb"></ol>
                        </nav>
                    </div>
                </div>
            </section>

            <section className="p70">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <h1>Contact Us</h1>

                            <p className="green-text">
                                Thank you for showing your interest in getting connected with us.
                            </p>

                            <p>
                                We hope that the online presence has helped you well in knowing about us.
                                For any further queries please do visit our showroom.
                            </p>

                            <div>
                                <p>&nbsp;</p>

                                <h2 className="green-text">
                                    Sakhi Designer Studio
                                </h2>

                                <p>
                                    Basement-L-105, Prime Mall, Near Alpha, Irla Society Road,
                                    Vile Parle West, Mumbai, Maharashtra 400056
                                </p>

                                <p>
                                    Phone: +91-9324105995, +91-9167005995 | 022-26705995
                                    <br />
                                    Email: mamta_sakhi@yahoo.co.in
                                </p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <form onSubmit={handleSubmit}>
                                <h2 className="green-text mb-3">
                                    Contact Form
                                </h2>

                                {error && (
                                    <div className="alert alert-danger py-2">
                                        {error}
                                    </div>
                                )}

                                {success && (
                                    <div className="alert alert-success py-2">
                                        {success}
                                    </div>
                                )}

                                <div className="mb-3">
                                    <label className="form-label">
                                        Name
                                    </label>

                                    <input
                                        type="text"
                                        name="name"
                                        className="form-control"
                                        placeholder="Your Name"
                                        value={form.name}
                                        onChange={handleChange}
                                        disabled={loading}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Email
                                    </label>

                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control"
                                        placeholder="Your Email"
                                        value={form.email}
                                        onChange={handleChange}
                                        disabled={loading}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Phone
                                    </label>

                                    <input
                                        type="text"
                                        name="phone"
                                        className="form-control"
                                        placeholder="Your Phone"
                                        value={form.phone}
                                        onChange={handleChange}
                                        maxLength="15"
                                        disabled={loading}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Message
                                    </label>

                                    <textarea
                                        name="message"
                                        className="form-control"
                                        rows="4"
                                        placeholder="Your Message"
                                        value={form.message}
                                        onChange={handleChange}
                                        disabled={loading}
                                    />
                                </div>

                                <div className="text-end">
                                    <button
                                        type="submit"
                                        className="btn text-white"
                                        style={{
                                            backgroundColor: "#a3895b",
                                        }}
                                        disabled={loading}
                                    >
                                        {loading
                                            ? "Sending..."
                                            : "Send Message"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-3">
                <div className="container">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.9904131636354!2d72.8407703!3d19.108076499999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c9c89e154a6d%3A0xd7d0a57f56e002ba!2sSakhi%20Designer%20Studio%20%7C%20Fashion%20Designer%20In%20Vile%20Parle!5e0!3m2!1sen!2sin!4v1780304742034!5m2!1sen!2sin"
                        width="100%"
                        height="450"
                        loading="lazy"
                        title="Sakhi Designer Studio Location"
                    />
                </div>
            </section>
        </div>
    );
};

export default Contact;